import { head } from 'lodash'

import {
  DROPDOWN_OPTIONS_ROLE,
  GALLERY_ROLE,
  GRID_ROLE,
  REPEATER_ROLE,
  SELECTION_TAGS_OPTIONS_ROLE,
} from '@wix/wix-data-client-common-standalone'
import {
  DYNAMIC_PAGE_TYPES,
  getTypeOfProbableDynamicPage,
  ROUTER_DATASET,
} from '@wix/wix-data-client-common'

import type { ComponentRef } from '@wix/editor-platform-sdk-types'
import type { EditorSDK } from '@wix/wix-data-client-common-standalone'
import type { DatasetType, AppApi } from '@wix/wix-data-client-common'

const ITEM_VIEW_INCOMPATBIBLE_ROLES = [
  DROPDOWN_OPTIONS_ROLE,
  GALLERY_ROLE,
  GRID_ROLE,
  REPEATER_ROLE,
  SELECTION_TAGS_OPTIONS_ROLE,
]

export const itemViewShouldBeUsedInsteadOfCollectionView = async ({
  editorSdkProxy,
  appApi,
  componentRef,
  datasetType,
}: {
  editorSdkProxy: EditorSDK
  appApi: AppApi
  componentRef: ComponentRef
  datasetType: DatasetType
}) => {
  if (
    datasetType === ROUTER_DATASET &&
    (await getTypeOfProbableDynamicPage({
      editorSdkProxy,
      pageRef: await editorSdkProxy.document.pages.getCurrent(),
    })) === DYNAMIC_PAGE_TYPES.ITEM_PAGE
  ) {
    const binding = head(await appApi.fetchComponentBindings(componentRef))

    if (binding && ITEM_VIEW_INCOMPATBIBLE_ROLES.includes(binding.role)) {
      return false
    }

    const componentIsInsideRepeater =
      await editorSdkProxy.components.isRepeatedComponent({ componentRef })

    return !componentIsInsideRepeater
  }
  return false
}
